import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import { Button, ButtonGroup, Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import {
    Accounting,
    AccountingLoadParams,
    ApiAccountingInvoiced,
    ApiAccountingLoad,
    CourseBookings,
    ServerResponse,
} from '../../api';
import TableBoxForCPBookingsProofed from '../../components/cpBookingRequests/TableBoxForCPBookingsProofed';
import Footer from '../../components/footer/Footer';
import HeaderLoggedIn from '../../components/headerLoggedIn/HeaderLoggedIn';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import { IThConfig } from '../../components/sortableTh/SortableTh';
import { InvoiceState } from '../cpBookings/CPBookings';

interface AdminAccountingDetailsProps {
    match: { params: { id: string; month: string } };
}

interface AdminAccountingDetailsState {
    listData: Accounting;
    loading: boolean;
    searchParams: AccountingLoadParams;
    serverResponse?: ServerResponse;
    weDontHaveData: boolean;
}

export default class AdminAccountingDetails extends React.PureComponent<
    AdminAccountingDetailsProps,
    AdminAccountingDetailsState
> {
    private renderTHeadLineArrays: IThConfig[] = [
        { name: 'Teilnehmer', width: '45%' },
        { name: 'Buchungdatum', width: '15%' },
        { name: 'Buchungsoptionen', width: '15%' },
        { name: 'Gebühr', width: '15%' },
        { name: 'Provision', width: '10%' },
    ];
    constructor(props: AdminAccountingDetailsProps) {
        super(props);
        this.state = {
            listData: {
                Appointments: 0,
                Bookings: 0,
                CommissionSum: 0,
                CourseBookings: [],
                CourseProviderCommission: 0,
                CourseProviderID: '',
                CourseProviderName: '',
                CourseProviderVat: 'true',
                ID: '',
                InsertDate: {},
                InvoiceDate: {},
                InvoiceState: InvoiceState.Virtual,
                Month: '',
                Sum: 0,
                UpdateDate: {},
            },
            loading: true,
            searchParams: {
                ID: '',
                Month: '',
            },
            serverResponse: undefined,
            weDontHaveData: false,
        };
    }

    public componentDidMount() {
        const cpID = this.props.match.params.id;
        const month = this.props.match.params.month;
        this.setState({ searchParams: { ID: cpID, Month: month } }, () => {
            this.getCourseProvider();
        });
    }

    public render() {
        const { listData, searchParams, weDontHaveData, loading, serverResponse } = this.state;

        return (
            <NetworkOverlay loading={loading} serverResponse={serverResponse}>
                <HeaderLoggedIn />
                <Container>
                    <Row>
                        <Col md={5}>
                            <h3>{listData.CourseProviderName}</h3>
                        </Col>
                        <Col md={7} />
                    </Row>
                    <Row>
                        <Col md={8}>
                            {!weDontHaveData && (
                                <>
                                    <h4>
                                        <b>
                                            {TR.adminAccountingDetails_bookings_for}{' '}
                                            {moment(listData.Month).format('MMMM YYYY')}
                                        </b>
                                    </h4>
                                    <div className="text center h4">{this.getInvoiceState(listData.InvoiceState)}</div>
                                </>
                            )}
                            {weDontHaveData && (
                                <h4>
                                    <b>
                                        {TR.adminAccountingDetails_bookings_for}{' '}
                                        {moment(searchParams.Month).format('MMMM YYYY')}
                                    </b>
                                </h4>
                            )}
                        </Col>
                        <Col md={4} className="text-right">
                            <ButtonGroup>
                                <Button
                                    size="sm"
                                    color="danger"
                                    onClick={() => {
                                        const newSearchParams = searchParams;
                                        newSearchParams.Month = moment(searchParams.Month)
                                            .subtract(1, 'months')
                                            .format('YYYY-MM')
                                            .toString();
                                        this.setState({ searchParams: newSearchParams });
                                        this.changeValue('Month', searchParams.Month, true);
                                    }}
                                >
                                    <span>{TR.adminAccountingDetails_prev_month}</span>
                                </Button>
                                <Button
                                    disabled={
                                        moment(searchParams.Month).format('YYYY-MM').toString() !==
                                        moment().subtract(1, 'months').format('YYYY-MM').toString()
                                            ? false
                                            : true
                                    }
                                    style={
                                        moment(searchParams.Month).format('YYYY-MM').toString() !==
                                        moment().subtract(1, 'months').format('YYYY-MM').toString()
                                            ? undefined
                                            : { ...{ pointerEvents: 'none' } }
                                    }
                                    size="sm"
                                    color="danger"
                                    onClick={() => {
                                        const newSearchParams = searchParams;
                                        newSearchParams.Month = moment(searchParams.Month)
                                            .add(1, 'months')
                                            .format('YYYY-MM')
                                            .toString();
                                        this.setState({ searchParams: newSearchParams });
                                        this.changeValue('Month', searchParams.Month, true);
                                    }}
                                >
                                    <span>{TR.adminAccountingDetails_next_month}</span>
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                    {(weDontHaveData || listData.InvoiceState === InvoiceState.Virtual) && (
                        <div className="mt-5 text-center h3">{TR.adminAccountingDetails_no_invoice}</div>
                    )}
                    {!weDontHaveData &&
                        listData.InvoiceState !== InvoiceState.Virtual &&
                        listData.CourseBookings.map((obj: CourseBookings, index: number) => {
                            return (
                                <React.Fragment key={(index + 1) * 1000 + (obj.CourseName + 1)}>
                                    <Row className="mt-4">
                                        <Col>
                                            <h5 className="mb-3">
                                                {obj.CourseName}
                                                &nbsp;am&nbsp;
                                                {obj.Bookings && moment(obj.CourseDate).format('DD.MM.YYYY')}
                                            </h5>
                                            <TableBoxForCPBookingsProofed
                                                listData={obj.Bookings}
                                                renderTHeadLine={this.renderTHeadLineArrays}
                                            />
                                        </Col>
                                    </Row>
                                    <br />
                                </React.Fragment>
                            );
                        })}
                    {!weDontHaveData && listData.InvoiceState !== InvoiceState.Virtual && (
                        <Row>
                            <Col md={10} />
                            <Col md={2} className="text-right">
                                {this.formatNumber(listData.Sum)}
                                &nbsp;€&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;
                                <strong>
                                    {this.formatNumber(listData.CommissionSum)}
                                    &nbsp;€
                                </strong>
                            </Col>
                        </Row>
                    )}
                    {!weDontHaveData && listData.InvoiceState !== 'invoiced' && (
                        <Row className="mt-5">
                            <Col md={8} />
                            <Col md={4}>
                                <Button
                                    block={true}
                                    size="sm"
                                    color="danger"
                                    onClick={() => {
                                        this.InvoiceCourseProvider(listData.ID);
                                    }}
                                >
                                    <span>{TR.adminAccountingDetails_invoice}</span>
                                </Button>
                            </Col>
                        </Row>
                    )}
                </Container>
                <Footer />
            </NetworkOverlay>
        );
    }

    private formatNumber = (n: number) => {
        return n.toLocaleString('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            useGrouping: false,
        });
    };

    private InvoiceCourseProvider = (id: string) => {
        this.setState({ loading: true });
        ApiAccountingInvoiced({ ...{ ID: id } }, (sr) => {
            if (sr.OK) {
                this.getCourseProvider();
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };

    private changeValue = (fieldName: string, value: string | boolean | number, reload: boolean = false) => {
        const newParams = { ...this.state.searchParams };
        // @ts-ignore
        newParams[fieldName] = value;
        if (reload) {
            this.setState({ searchParams: newParams }, this.getCourseProvider);
        } else {
            this.setState({ searchParams: newParams });
        }
    };

    private getInvoiceState = (myStatus: string) => {
        return myStatus === InvoiceState.Invoiced ? 'Abgerechnet' : '';
    };

    private getCourseProvider = () => {
        ApiAccountingLoad({ ...this.state.searchParams }, (sr) => {
            if (sr.OK && sr.Data !== null) {
                this.setState({
                    listData: sr.Data ? sr.Data : this.state.listData,
                    loading: false,
                    serverResponse: sr,
                    weDontHaveData: false,
                });
            } else if (sr.Data === null) {
                this.setState({ loading: false, weDontHaveData: true });
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/adminAccountingDetails/AdminAccountingDetails.tsx